module.exports = __webpack_public_path__ + "static/media/imgTechMobile.cd81eef7.png";